
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le laboratoire français Sanofi, l’un des principaux producteurs de vaccins au
monde, a développé un vaccin avec un autre poids lourd, le britannique GSK (qui
lui fournit l’adjuvant). Les deux compagnies, qui misent sur les protéines
recombinantes, espéraient démarrer la toute dernière phase des essais sur
l’homme à fin décembre 2020, puis demander une homologation aux autorités. Des
contrats de livraison avaient même été passés.`}</p>
    <p>{`Mais les premiers résultats n’ont pas répondu aux attentes, avec une efficacité
jugée insuffisante chez les personnes de plus de 50 ans. Le 11 décembre 2020,
`}<a parentName="p" {...{
        "href": "758476588724"
      }}>{`les deux entreprises ont expliqué qu’elles voulaient revoir la formule`}</a>{`
et lançaient une nouvelle phase d’essais.`}</p>
    <p>{`En mai 2021,
`}<a parentName="p" {...{
        "href": "https://www.sanofi.com/fr/nos-vaccins-contre-la-covid-19"
      }}>{`des nouveaux essais de phase 2`}</a>{`
ont montré une "forte réponse immunitaire chez les adultes, toutes tranches
d'âge confondues", selon le communiqué des deux firmes.`}</p>
    <p>{`Celles-ci ont lancé le recrutement de participants pour une étude de phase 3. Si
les résultats sont positifs, le vaccin pourrait être approuvé à fin 2021,
ont-elles précisé. En Europe, ces doses semblent surtout promises à une
utilisation en rappel ou pour celles et ceux qui ne veulent pas recourir à
l'ARNm.`}</p>
    <p>{`En septembre 2021,
`}<a parentName="p" {...{
        "href": "779845396977"
      }}>{`Sanofi a en outre annoncé qu'il ne commercialiserait pas de vaccin à ARN messager`}</a>{`.
Malgré des résultats intermédiaires qualifiés de positifs, le laboratoire
considère que son produit arriverait trop tard sur le marché alors que 12
milliards de doses auront été produites d'ici la fin de l'année.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;